<template>
  <nav>
    <div class="nav-wrapper" :style="'background-color: ' + this.$store.state.empresa.cor_primaria">
      <div class="">
        <a class="brand-logo">
          <div align="center"><img src="@/assets/logo-branco.png" class="logo"></div>
        </a>
      </div>
    </div>
    <slot></slot>
  </nav>

</template>

<script>

export default {
  name: "NavBarOnly",
  data(){
    return{
    }
  },
  updated() {

  },
  methods:{

  }
}
</script>

<style scoped>

.logo {
  padding: 9px;
  width: 210px;
}

@media only screen and (max-width : 992px) {
  .logo {
    padding-top: 7px;
    width: 185px;
  }
}

.sidenav li > a {
  color: white;
}

.nav-grupo-conteiner{
  margin-top: 50px;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-grupo{
  background-color: #f2f2f2;
  /*height: 100px;*/
  height: auto;
}


nav i {
  line-height: 40px;
}

nav {
  /*color: #fff;*/
  /*background-color: #ee6e73;*/
  /*width: 100%;*/
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/NavBarOnly.vue